import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitPlanningPeriod = createSelector(
  [selectFinancialCockpitState],
  ({ planningPeriod }) => planningPeriod
)
